module.exports = __webpack_public_path__ + "static/counter_img-af4b75fa26fa946e7996737ffb4cf4f5.jpg";